export default "__VITE_ASSET__BeXYRP0Z__"